import React from 'react';
import { useLocation } from 'react-router-dom';

import { WorkspacesRoutes } from '@futrli/predict-next/workspaces/workspaces-list/routes';

import { getWorkspacesRouterTarget } from './workspaces-routing-policy';
import { WorkspacesManagementRouter } from '../components/workspaces-management-router';

export const WorkspacesHybridRouter = () => {
  const { pathname } = useLocation();

  if (getWorkspacesRouterTarget(pathname) === 'redesigned-listing') {
    return <WorkspacesRoutes />;
  }

  return <WorkspacesManagementRouter />;
};
